import profileImage from "../../img/profile.jpg";

import classes from "./AboutMe.module.css"

function AboutMe() {
	const yearsMakingGames = new Date().getFullYear() - 2017;

	return (
		<div className={classes.aboutMe}>
			<p>
				This is my portfolio where I showcase my game development related projects. Although I focus on programming, due to the multimedia nature of video games, I believe pictures and descriptions do them more justice than a repository with code.
			</p>
			<p>
				For my other coding projects, you can visit my Github profile (link in the top left). There I have a variety of projects, most of them focused on low level programming.
			</p>
			<p>
				Most of the projects on this website have a downloadable build, so you can try them out yourself. I hope you enjoy them!
			</p>
			<img className={classes.imageAboutPage} src={profileImage} alt="" />
			<div className={classes.description}>
				<p>
					<b>About Me</b>
				</p>
				<p>
					My name is Bogdan.
					I started making games about {yearsMakingGames} years ago, by learning Unity.
					I found out that I like this so much that I could make games for the
					rest of my life. Since then, I have been to several events and
					started many small projects of my own and even released one game.
				</p>
				<p>
					I have experience in programming video games, both single-player
					and multiplayer. I have knowledge in other software development
					domains and lower-level and hardware stuff.
				</p>
				<p>
					Regarding game development, I have worked with Unity, Unreal Engine and OpenGL, using C# and C++.
				</p>
				<p>
					I adore everything related to programming, learning and games. I view
					programming as very complex puzzle solving and in some way as an
					art, and there is nothing I would love to do more.
				</p>
				<p>
					Currently, I am trying to get more serious about making games,
					gaining experience in a professional studio, learning increasingly
					complex stuff, and releasing my own games to the market.
				</p>
			</div>
		</div>
	);
}

export default AboutMe;
